import type { ReactNode } from 'react';
import { Transition } from 'react-transition-group';
import { SwipeProvider } from './SwipeContext';
import { transitionTimeouts } from './constants';
import { Portal } from '@simplywallst/ui-core';

import { TransitionStatusProvider } from './TransitionStatusContext';
interface Props {
  open: boolean;
  onClose: () => void;
  onClosed?: () => void;
  children: ReactNode;
  className?: string;
}

const ActionSheet = ({
  open,
  onClose,
  onClosed,
  children,
  className,
}: Props) => {
  if (RUNTIME_ENV === 'server' && typeof document === 'undefined') return null;

  return (
    <SwipeProvider onClose={onClose}>
      <Transition
        in={open}
        timeout={transitionTimeouts}
        mountOnEnter
        unmountOnExit
        onExited={() => onClosed?.()}
      >
        {(state) => {
          return (
            <TransitionStatusProvider state={state}>
              <Portal className={className}>{children}</Portal>
            </TransitionStatusProvider>
          );
        }}
      </Transition>
    </SwipeProvider>
  );
};

export default ActionSheet;
